var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScoreActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6063_14467)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7881 5.39355H5.78809L5.78809 21.3936H19.7881V5.39355ZM5.78809 3.39355C4.68352 3.39355 3.78809 4.28899 3.78809 5.39356V21.3936C3.78809 22.4981 4.68352 23.3936 5.78809 23.3936H19.7881C20.8927 23.3936 21.7881 22.4981 21.7881 21.3936V5.39355C21.7881 4.28899 20.8927 3.39355 19.7881 3.39355H5.78809Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7881 3.39355C15.7881 5.05041 14.4449 6.39355 12.7881 6.39355C11.1312 6.39355 9.78809 5.05041 9.78809 3.39355C9.78809 1.7367 11.1312 0.393555 12.7881 0.393555C14.4449 0.393555 15.7881 1.7367 15.7881 3.39355Z",
    fill: "#0065F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7881 4.39355C13.3404 4.39355 13.7881 3.94584 13.7881 3.39355C13.7881 2.84127 13.3404 2.39355 12.7881 2.39355C12.2358 2.39355 11.7881 2.84127 11.7881 3.39355C11.7881 3.94584 12.2358 4.39355 12.7881 4.39355ZM12.7881 6.39355C14.4449 6.39355 15.7881 5.05041 15.7881 3.39355C15.7881 1.7367 14.4449 0.393555 12.7881 0.393555C11.1312 0.393555 9.78809 1.7367 9.78809 3.39355C9.78809 5.05041 11.1312 6.39355 12.7881 6.39355Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7881 4.39355H7.78809L8.78809 6.39355H16.7881L17.7881 4.39355Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36276 4.13069C7.45386 3.98328 7.6148 3.89355 7.78809 3.89355H17.7881C17.9614 3.89355 18.1223 3.98328 18.2134 4.13069C18.3045 4.2781 18.3128 4.46217 18.2353 4.61716L17.2353 6.61716C17.1506 6.78655 16.9775 6.89355 16.7881 6.89355H8.78809C8.5987 6.89355 8.42557 6.78655 8.34087 6.61716L7.34087 4.61716C7.26338 4.46217 7.27166 4.2781 7.36276 4.13069ZM8.5971 4.89355L9.0971 5.89355H16.4791L16.9791 4.89355H8.5971Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03809 11.3936C8.03809 10.9793 8.37387 10.6436 8.78809 10.6436L12.7881 10.6436C13.2023 10.6436 13.5381 10.9793 13.5381 11.3936C13.5381 11.8078 13.2023 12.1436 12.7881 12.1436L8.78809 12.1436C8.37387 12.1436 8.03809 11.8078 8.03809 11.3936Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03809 16.3936C8.03809 15.9793 8.37387 15.6436 8.78809 15.6436L12.7881 15.6436C13.2023 15.6436 13.5381 15.9793 13.5381 16.3936C13.5381 16.8078 13.2023 17.1436 12.7881 17.1436L8.78809 17.1436C8.37387 17.1436 8.03809 16.8078 8.03809 16.3936Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7881 10.8936C14.7881 10.6174 15.0119 10.3936 15.2881 10.3936H16.2881C16.5642 10.3936 16.7881 10.6174 16.7881 10.8936V11.8936C16.7881 12.1697 16.5642 12.3936 16.2881 12.3936H15.2881C15.0119 12.3936 14.7881 12.1697 14.7881 11.8936V10.8936Z",
    fill: "#FFEA80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7881 15.8936C14.7881 15.6174 15.0119 15.3936 15.2881 15.3936H16.2881C16.5642 15.3936 16.7881 15.6174 16.7881 15.8936V16.8936C16.7881 17.1697 16.5642 17.3936 16.2881 17.3936H15.2881C15.0119 17.3936 14.7881 17.1697 14.7881 16.8936V15.8936Z",
    fill: "#FFEA80"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6063_14467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.788086 0.393555)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScoreActive);
export default __webpack_public_path__ + "static/media/scoreActive.546d40bbdf2e0f1e25a347f77f241e76.svg";
export { ForwardRef as ReactComponent };